import { render, staticRenderFns } from "./DoctorFormIT.vue?vue&type=template&id=3745eeb8"
import script from "./DoctorFormIT.vue?vue&type=script&lang=js"
export * from "./DoctorFormIT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports